import React, { Component } from "react";
import { connect } from "react-redux";
import Login from "./Login";
import { authenticate } from "actions/login";

const mapDispatchToProps = {
  authenticate
};

const mapStateToProps = state => ({
  isAuthenticated: state.login.user !== null,
  isAuthenticating: state.login.isAuthenticating,
  isAdmin: state.login.user && state.login.user.is_admin,
  isValidating: state.user.isFetching
});

const withAuthorization = () => SecuredComponent => {
  class SecuredWrappedComponent extends Component {
    componentDidMount() {
      const token = localStorage.getItem("api_token");
      if (token) {
        this.props.authenticate();
      }
    }

    render() {
      const {
        isAuthenticated,
        isAuthenticating,
        isAdmin,
        isValidating
      } = this.props;
      if (isAuthenticating || isValidating) {
        return <div>Spinner</div>;
      }
      if (!isAuthenticated) {
        return <Login />;
      }
      if (!isAdmin) {
        return <div>Forbidden</div>;
      }
      if (SecuredComponent) {
        return <SecuredComponent {...this.props} />;
      } else {
        return this.props.children;
      }
    }
  }
  return connect(mapStateToProps, mapDispatchToProps)(SecuredWrappedComponent);
};

export default withAuthorization;



// WEBPACK FOOTER //
// ./src/components/withAuthorization.js